
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Section, Field } from '@/shared/types/aperTemplate';
import SectionItem from './SectionItem.vue';

@Component({
  components: { SectionItem }
})
export default class SectionList extends Vue {
  @Prop({ type: Array, required: true }) readonly sections!: Section[];
}
